import React from 'react'
import { Form } from "antd";
import ResponsiveModal from "@components/ResponsiveModal";
import TreeSelect from "@components/ResponsiveTreeSelect";

export const MoveToModal = ({treeData, open, setOpen, moveForm, handleMoveTo}) => {


  if(!open) {
    return null
  }
  const formatTreeData = (treeData) => treeData.map(item => {
    if(Array.isArray(item.children) && item.children.length > 0) {
      return {
        value:  item.isRoot ? 'root' : item.id,
        title: item.title,
        label: item.title,
        children: formatTreeData(item.children),
        disabled: item.isSystem ? !item?.context?.canMove : false
      }
    }
    return {
      value:  item.isRoot ? 'root' : item.id,
      label: item.title,
      title: item.title,
      disabled: item.isSystem ? !item?.context?.canMove : false
    }
  })

  return (<ResponsiveModal title="Move to" open={open} onCancel={() => setOpen(false)} onOk={handleMoveTo} destroyOnClose>
    <Form form={moveForm} autoComplete="off">
      <Form.Item label="Folder" name="folder" rules={[{required: true, message: 'Please select a destination folder'}]}>
        <TreeSelect
          treeData={formatTreeData(treeData)}
          showCheckedStrategy={TreeSelect.SHOW_PARENT}
          treeDefaultExpandAll
          placeholder="Select a folder..."
        />
      </Form.Item>
    </Form>
  </ResponsiveModal>)
}
